import React from 'react';
import { IntlProvider } from 'react-intl-next';
import { Text } from '@atlaskit/primitives/compiled';
import { DEFAULT_LOCALE, getCodesFromLocale, useLazyMessages } from './utils';
export const ProformaIntlProvider = ({
  children,
  locale,
  messages
}) => {
  var _getCodesFromLocale;
  const {
    language,
    country
  } = (_getCodesFromLocale = getCodesFromLocale(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {};
  const lazyMessages = useLazyMessages(messages, language !== null && language !== void 0 ? language : DEFAULT_LOCALE, country);
  if (lazyMessages === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: lazyMessages,
    locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
    defaultLocale: DEFAULT_LOCALE,
    defaultRichTextElements: {
      b: chunks => /*#__PURE__*/React.createElement(Text, {
        weight: "bold"
      }, chunks),
      strong: chunks => /*#__PURE__*/React.createElement(Text, {
        as: "strong"
      }, chunks)
    }
  }, children);
};